import React from 'react';
import { connect } from 'react-redux';
import RightPanelBottom from './rightPanelBottom';
import RightPanelTop from './rightPanelTop';
import CenterPanel from './centerPanel';
import GroupFormPage from '../../../../containers/GroupFormPage';
import PageHeader from '../../header';
import { getGroups } from '../../../../actions/group';
import { getOrganisationsWithPermission } from '../../../../actions/organisation';
import { getCallQualityProfiles } from '../../../../actions/portalSetting';

@connect(mapStateToProps)
export default class ViewAllGroups extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      groupsFiltered: [],
      groupsGray: [],
      currentGroupFilter: '',
      noRightMenu: props.noRightMenu || false,
    };
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA

    //START this code is to apply filters when data is being retrieved
    let dontSetState = true;

    let resultOfFilterOne = {};
    resultOfFilterOne = this.groupFilterSearch(dontSetState, props.groups, props.currentGroupFilter);
    let filteredAndGrayGroups = {
      groupsGray: [],
      groupsFiltered: [],
    };
    if (resultOfFilterOne == undefined) filteredAndGrayGroups.groupsFiltered = props.groupsFiltered;
    else filteredAndGrayGroups = resultOfFilterOne;

    //END this code is to apply filters when data is being retrieved
    this.setState({
      groups: props.groups,
      groupsGray: filteredAndGrayGroups.groupsGray,
      groupsFiltered: filteredAndGrayGroups.groupsFiltered,
      organisations: props.organisations,
      isFetchingOrganisation: props.isFetchingOrganisation,
      portalSetting: props.portalSetting,
    });
  };

  UNSAFE_componentWillMount = () => {
    let cb = () => {};
    if (!this.props.noHeader) {
      //TODO: UNDERSTAND WHAT IS THIS ABOUT
      cb = () => {
        // window.$('.ui.sticky.view-all-group:visible').sticky({ context: '.view-all-group-container:visible' });
      };
    }

    this.props.dispatch(getGroups(undefined, cb));
    this.props.dispatch(getOrganisationsWithPermission(APP.LANGUAGE.Permission.CREATE_GROUP)); //fetch groups
    this.props.dispatch(getCallQualityProfiles()); //getting call quality profile dropdown
  };

  groupFilterSearch = (dontSetState, groups, currentFilter) => {
    let groupsToFilter = groups || this.state.groups;
    let smartQuery = null;
    if (currentFilter.indexOf('¤') > -1) {
      let splitted = currentFilter.split('¤');
      smartQuery = (object) => {
        if (object[splitted[0]]) {
          if (object[splitted[0]].toLowerCase() == splitted[1].toLowerCase()) {
            return true;
          } else return false;
        } else {
          return false;
        }
      };
    }

    let containsSearchExpression = (group) => {
      return (
        (
          group.orgAbbreviatedName.toLowerCase() +
          (group.shortDescription ? group.shortDescription.toLowerCase() : '') +
          group.name.toLowerCase()
        ).indexOf(currentFilter.toLowerCase()) > -1
      );
    };
    let filtered = groupsToFilter.filter(smartQuery || containsSearchExpression);

    let differenceBetweenArrays = groupsToFilter.filter(function (obj) {
      return !filtered.some(function (obj2) {
        return obj.id == obj2.id;
      });
    });

    if (!dontSetState)
      this.setState({
        groupsGray: differenceBetweenArrays,
        groupsFiltered: filtered,
      });
    else return { groupsGray: differenceBetweenArrays, groupsFiltered: filtered };
  };

  render() {
    let modals = '';
    let header = '';
    if (!this.state.noHeader) {
      header = (
        <span>
          <PageHeader title={APP.LANGUAGE.ViewGroup.Title}>
            <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.GroupsIcon.default} />
          </PageHeader>
        </span>
      );
    }

    return (
      <div>
        {modals}
        {header}
        <div className="main-ui-container group-view-all" data-rendered-as-container={this.state.noRightMenu}>
          <div className="view-all-group-container">
            <div
              className="right ui rail fade-in"
              data-show={
                !this.state.isFetchingOrganisation ||
                !(this.state.organisations == undefined || this.state.organisations.length == 0)
              }
            >
              <div className="ui sticky view-all-group">
                <span
                  data-show={
                    !(this.state.organisations == undefined || this.state.organisations.length == 0) &&
                    !(
                      this.state.portalSetting == undefined ||
                      !this.state.portalSetting.videoCallQualityProfiles ||
                      this.state.portalSetting.videoCallQualityProfiles.length == 0
                    )
                  }
                >
                  <RightPanelTop />
                </span>
                <RightPanelBottom />
              </div>
            </div>

            <CenterPanel
              noHeader={this.state.noHeader}
              groups={this.props.groups}
              doSorting={this.doSorting}
              groupsGray={this.state.groupsGray}
              currentGroupFilter={this.props.currentGroupFilter}
              groupsFiltered={this.state.groupsFiltered}
              groupFilterSearch={this.groupFilterSearch}
            />
            <div
              className="bottom-rail-with-left-and-right-content fade-in"
              data-show={
                !this.state.isFetchingOrganisation ||
                !(this.state.organisations == undefined || this.state.organisations.length == 0)
              }
            >
              <span data-show={!(this.state.organisations == undefined || this.state.organisations.length == 0)}>
                <RightPanelTop />
              </span>
              <RightPanelBottom />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    groups: state.groupsReducer.groups,
    groupsFiltered: state.groupsReducer.groups,
    currentGroupFilter: state.groupsReducer.currentGroupFilter,
    organisations: state.organisationsReducer.groupOrganisations,
    portalSetting: state.portalSettingReducer.portalSetting,
    isFetchingOrganisation: state.organisationsReducer.fetchingOrganisationsWithPermission,
  };
}
